import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import * as api from "Api";

import { setNavCommunity, setSelectedLayout, setDrawerIframe } from "Actions";
import { changeNavCommunity } from "Thunks";

import { getUserLayouts } from "Utils";
import _ from "i18n";

import { TTP_PORTAL_URL } from "../../config";

export class Layouts extends Component {
  static propTypes = {
    setNavCommunity: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      hasPublicPortal: false,
      subdomain: "",
      publicPortalConnected: false
    };
  }

  componentDidMount() {
    const { token, navCommunity } = this.props;
    if (navCommunity) {
      api
        .getPublicPage({
          token,
          communityId: navCommunity.id
        })
        .then(resp => {
          if (resp.data.data && resp.data.data.length > 0) {
            this.setState({
              hasPublicPortal: true,
              subdomain: `/public/${navCommunity.url}/${navCommunity.id}`
            });
          }
        });
    }
  }

  componentDidUpdate(prevProps) {
    const { pubCommunity, currentPage } = this.props;

    if (!prevProps.pubCommunity && pubCommunity) {
      this.setState({
        hasPublicPortal: true,
        publicPortalConnected: currentPage === "HOME_PAGE"
      });
    }
  }

  handleSelectCommunity = community => {
    const { setNavCommunity, changeNavCommunity } = this.props;
    setNavCommunity(community);
    changeNavCommunity(community.id);
    setTimeout(() => {
      window.location.reload(true);
    }, 200);
  };

  selectLayout(index) {
    const {
      setSelectedLayout,
      setDrawerIframe,
      blocs,
      user,
      navCommunity
    } = this.props;
    setSelectedLayout(index);
    const layouts = getUserLayouts(user, blocs, navCommunity.id);
    if (layouts && layouts.length > index) {
      setDrawerIframe(layouts[index].config[0].url);
    }
  }

  renderLayouts() {
    const { blocs, user, navCommunity } = this.props;
    const { hasPublicPortal, subdomain, publicPortalConnected } = this.state;

    if (!navCommunity || ((!blocs || blocs.length === 0) && !hasPublicPortal)) {
      return null;
    }
    const layouts = getUserLayouts(user, blocs, navCommunity.id);
    const layoutsBlock = layouts.map((bloc, index) => {
      return (
        <li className="menu__sub-child" key={`bloc-${index}`}>
          {publicPortalConnected ? (
            <NavLink
              to={`/community/${navCommunity.url}/${navCommunity.id}`}
              activeClassName="active"
              onClick={() => this.selectLayout(index)}
            >
              {bloc.name}
            </NavLink>
          ) : (
            <a
              activeClassName="active"
              onClick={() => this.selectLayout(index)}
            >
              {bloc.name}
            </a>
          )}
        </li>
      );
    });
    if (hasPublicPortal) {
      layoutsBlock.push(
        <li className="menu__sub-child" key={`bloc-100`}>
          <NavLink activeClassName="active" to={subdomain}>
            {_("Public Portal")}
          </NavLink>
        </li>
      );
    }

    return (
      <div className="menu__dropdown">
        <ul>{layoutsBlock}</ul>
      </div>
    );
  }

  getLayoutDisplayName(blocs, selectedLayout) {
    return blocs.length > selectedLayout ? blocs[selectedLayout].name : "";
  }

  render() {
    const {
      blocs,
      selectedLayout,
      user,
      navCommunity,
      pubCommunity,
      currentPage
    } = this.props;
    const { hasPublicPortal } = this.state;

    if (!navCommunity) {
      return null;
    }

    const layouts = getUserLayouts(user, blocs, navCommunity.id);
    if ((!layouts || layouts.length < 2) && !hasPublicPortal) {
      return null;
    }
    return (
      <ul className="menu">
        <li className="menu__has-child menu__community">
          <a activeClassName="active" className="menu__link">
            <span>
              {pubCommunity && currentPage === "HOME_PAGE"
                ? _("Public Portal")
                : this.getLayoutDisplayName(layouts, selectedLayout)}
            </span>
            <i className="icon icon-arrow-down" />
          </a>
          {this.renderLayouts()}
        </li>
      </ul>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  user: state.auth.user,
  token: state.auth.token,
  routing: state.routing,
  blocs: state.hub.blocs,
  selectedLayout: state.auth.selectedLayout,
  navCommunity: state.auth.navCommunity,
  pubCommunity: state.params.publicPortal.community,
  currentPage: state.params.currentNavPage
});

const mapDispatchToProps = dispatch => ({
  setSelectedLayout: index => dispatch(setSelectedLayout(index)),
  setDrawerIframe: url => dispatch(setDrawerIframe(url))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layouts);



// WEBPACK FOOTER //
// ./src/components/Menu/Layouts.js